import {
  ActionIcon,
  Button,
  Group,
  Modal,
  SimpleGrid,
  Stack,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import {
  IconPlus,
  IconShare3,
  IconUserPlus,
  IconUserUp,
} from "@tabler/icons-react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useCallback, useState } from "react";
import BackButton from "../../../../components/View/BackButton";
import { modals } from "@mantine/modals";
import { useConfigStore } from "../../../../stores/ConfigStore";
import { addContact } from "../../../../api/ContactAPI";
import { useParams } from "react-router-dom";

const ContactCreate = ({ onCreated, isMinimized }) => {
  const lang = useLanguage((s) => s.language);
  const { contactListId } = useParams();
  const columns = useConfigStore((s) => s.datafields);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dirty, setDirty] = useState(false);
  const [errors, setErrors] = useState({});

  const handleOpen = () => {
    setOpen(true);
    setLoading(false);
    setDirty(false);

    setErrors({});
  };

  const handleClose = useCallback(
    (isSubmit) => {
      if (dirty && !isSubmit)
        modals.openConfirmModal({
          title: "Attention",
          children: <Text size="sm">{lang.leads.edition_not_saved}</Text>,
          labels: { confirm: lang.global.close, cancel: lang.global.cancel },
          onCancel: () => {},
          onConfirm: () => {
            setOpen(false);
            setDirty(false);
          },
          centered: true,
        });
      else {
        setOpen(false);
        setDirty(false);
      }
    },
    [dirty, lang.global.cancel, lang.global.close, lang.leads.edition_not_saved]
  );

  const onSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    let properties = [];
    Object.keys(data).forEach((x) => {
      if (data[x]) {
        if (x !== "status") {
          properties.push({
            data_field_id: columns.find(
              (col) => col.identifier_placeholder === x
            )?.id,
            value: data[x],
          });
        }
      }
    });

    setErrors({});
    setLoading(true);

    addContact(parseInt(contactListId), properties)
      .then((response) => {
        setDirty(false);
        handleClose(true);
        onCreated?.();
      })
      .catch((error) => {
        let errorResponse = error.response.data.errors;
        let result = {};
        if (errorResponse.find((x) => x?.error?.includes("email"))) {
          result["%email%"] = true;
          document.getElementById("%email%").focus();
        }
        if (errorResponse.find((x) => x?.error?.includes("linkedin"))) {
          result["%linkedin_url%"] = true;
        }

        setErrors(result);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {!isMinimized ? (
        <Tooltip label={lang.contact_lists.create_contact}>
          <ActionIcon onClick={handleOpen} size="xl" variant={"light"}>
            <IconPlus size={24} />
          </ActionIcon>
        </Tooltip>
      ) : (
        <Button
          leftSection={<IconPlus size={18} />}
          radius={"md"}
          color="primary"
          onClick={handleOpen}
          size="md"
          variant={"light"}
          fz={16}
        >
          {lang.contact_lists.create_contact}
        </Button>
      )}

      <Modal
        size={"xl"}
        title={lang.contact_lists.create_contact}
        onClose={handleClose}
        opened={open}
      >
        <Stack
          component={"form"}
          onChange={() => setDirty(true)}
          onSubmit={onSubmit}
          h={"76vh"}
        >
          <SimpleGrid
            cols={2}
            flex={"1 1 auto"}
            h={0}
            style={{ overflow: "auto" }}
          >
            {columns
              .filter((x) => !x.readonly)
              .map((column, index) => {
                return (
                  <TextInput
                    key={column.id}
                    id={column.identifier_placeholder}
                    name={column.identifier_placeholder}
                    label={column.name}
                    placeholder={column.name}
                    type={
                      column.identifier_placeholder === "%email%"
                        ? "email"
                        : column.identifier_placeholder.includes("url")
                        ? "url"
                        : "text"
                    }
                    size="md"
                    error={errors[column.identifier_placeholder]}
                    leftSection={
                      column.created_by && !column.from_sharing ? (
                        <Tooltip label={lang.prm.toolbar.custom_datafield}>
                          <IconUserUp size={18} />
                        </Tooltip>
                      ) : (
                        column.created_by &&
                        column.from_sharing && (
                          <Tooltip label={lang.prm.toolbar.from_sharing}>
                            <IconShare3 size={18} />
                          </Tooltip>
                        )
                      )
                    }
                  />
                );
              })}
          </SimpleGrid>

          <Group justify="end">
            <BackButton size="md" onClick={handleClose} />

            <Button
              loading={loading}
              leftSection={<IconUserPlus size={18} />}
              type="submit"
              size="md"
            >
              {lang.contact_lists.create_contact}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};

export default ContactCreate;
